import { writable } from 'svelte/store';
import pixabayService from './pixabay.service';
const { subscribe, update, set } = writable({
    searching: false,
    page: 1
});
const actions = {
    search: (searchTerm) => update(store => {
        console.log('Searching for:', searchTerm);
        pixabayService.search(searchTerm).then(response => {
            update(store => ({
                ...store,
                searching: false,
                results: response.data.hits
            }));
        });
        return { ...store, searching: true, searchTerm, page: 1 };
    }),
    loadNextPage: () => update(store => {
        pixabayService.search(store.searchTerm, store.page + 1).then(response => {
            update(store => ({
                ...store,
                searching: false,
                results: [...store.results, ...response.data.hits]
            }));
        });
        return { ...store, searching: true, page: store.page + 1 };
    }),
    previousPage: () => update(store => {
        if (store.page == 1)
            return store;
        pixabayService.search(store.searchTerm, store.page - 1).then(response => {
            update(store => ({
                ...store,
                searching: false,
                results: response.data.hits
            }));
        });
        return { ...store, searching: true, page: store.page - 1 };
    })
};
export default {
    ...actions,
    subscribe,
    update
};
